// @flow
import React from 'react';
import type { Bloc, BlocContent, Attributes, LinkAttributes } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { convertCSS } from 'utils/convertUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  clubName: string,
};

export type Props = {
  childrens: ?Array<Bloc|BlocContent>,
  attributes: ?Attributes[],
  tagName: string
};

export const Component = (props: Props & StateProps) => {
  const { pathname } = window.location;
  const { clubName, attributes, tagName } = props;
  if (tagName && tagName === 'a') {
    const attr = attributes && renderLinkAttributes(attributes, clubName);
    if (attr && attr.href && attr.href.includes('mailto') && pathname.includes('organigramme')) {
      return <a {...attr}>{renderElement(props)}</a>;
    } else if (attr && attr.href && attr.href.includes('mailto')) {
      return <a {...attr}>{renderElement(props)}</a>;
    } else if (attr && attr.className === 'news news--row' && attr.title) {
      return <a {...attr}>{renderElement(props)}</a>;
    } else if (attr && attr.href && (attr.href === "http://cote-dirigeants.ffr.fr/login" || "http://formation.ffr.fr/")) {
      return <a {...attr}>{renderElement(props)}</a>;
    }
    return <a {...attr}>{renderElement(props)}</a>;
  }
  return <props.tagName {...renderAttributes(attributes ? attributes : [])}>{renderElement(props)}</props.tagName>;
};

const renderElement = (props: Props) => {
  if (props.childrens && props.childrens.length > 0) {
    return props.childrens.map((c: Bloc | BlocContent, index) => {
      if (c.type === 'text' && c.text) return c.text;
      else if (c.attributes) return <ContentBloc {...c} key={index} />;
      else return null;
    });
  }
  return null;
};

const renderAttributes = (attributes: ?Attributes[]) => {
  if (attributes && attributes.length > 0) {
    return attributes.reduce((acc, obj) => {
      if (obj.name === 'class' || obj.name === 'classname') {
        acc['className'] = obj.value;
      } else if (obj.name === 'stroke-width') {
        acc['strokeWidth'] = obj.value;
      } else if (obj.name === 'fill-rule') {
        acc['fillRule'] = obj.value;
      } else if (obj.name === 'datetime') {
        acc['dateTime'] = obj.value;
      } else if (obj.name === 'srcset') {
        acc['srcSet'] = obj.value;
      } else if (obj.name === 'frameborder') {
        acc['frameBorder'] = obj.value;
      } else if (obj.name === 'allowfullscreen') {
        acc['allowFullScreen'] = obj.value;
      } else if (obj.name === 'style') {
        acc[obj.name] = convertCSS(obj.value);
      } else if (obj.name === 'controls') {
				acc['controls'] = true;
			} else {
        acc[obj.name] = obj.value;
      }
      return { ...acc };
    }, {});
  }
  return null;
};

const renderLinkAttributes = (attributes: Attributes[], clubName: string): LinkAttributes => {
  if (attributes && attributes.length > 0) {
    const attrObject = attributes.reduce((acc, obj): LinkAttributes => {
      if (obj.name === 'class') {
        acc['className'] = obj.value;
        if (obj.value.includes('card')) {
          const GTMdata = attributes.filter(attr => attr.name === 'data-gtm');
          if (GTMdata.length) {
            const { titleCard, titleCTA } = JSON.parse(GTMdata[0].value);
            acc['onClick'] = handleTagEvent(`card_${titleCard}`, `clic_${titleCTA}`, clubName);
          }
        }
      } else if (obj.name === 'href') {
        acc['href'] = obj.value;
      } else if (obj.name === 'style') {
        acc[obj.name] = convertCSS(obj.value);
      } else if (obj.name === 'data-gtm') {
      } else {
        acc[obj.name] = obj.value;
      }
      return { ...acc };
    }, {});
    return attrObject;
  }
  return { href: '#' };
};

